<div class="row g-0" *ngIf="!operation.isFinished">
  <div class="order-item" [class.order-item--is-open]="isOpen">
    <div class="pointer me-3" (click)="operation.isSelected = !operation.isSelected" *ngIf="isSelectable">
      <i class="fa fa-check-square text-primary" *ngIf="operation.isSelected"></i>
      <i class="far fa-square" *ngIf="!operation.isSelected"></i>
    </div>

    <div class="d-flex flex-column me-2 mt-1">
      <div
        class="blinker blinker--red mb-2 pointer"
        tooltipStr="Odstupanje od plana"
        (click)="onOpenDeviationModal()"
        ngxClickStopPropagation
        *ngIf="operation.deviationFromPlan"></div>
      <div class="blinker blinker--blue" tooltipStr="Dodatno planiranje" *ngIf="operation.quantityToPlan !== 0"></div>
    </div>

    <div class="flex-column">
      <div *ngIf="operation.productName">Artikal: {{ operation.productName }}</div>
      <div class="fw-bold">{{ operation.name }}</div>
      <div class="font-12">{{ operation.machineName }}</div>
      <app-tag [sector]="operation.sector" [isActive]="true"></app-tag>
    </div>

    <div class="flex-column d-flex align-items-end justify-content-between ms-auto pointer" (click)="isDetailsModalVisible = true">
      <div>
        <span>{{ operation.timeConsumedEmployeeTotal | digitFormat }}</span>
        <span>/</span>
        <span>{{ operation.timeEstimatedEmployee | digitFormat }}</span>
        <span>/</span>
        <span>{{ operation.timeCorrectionEmployee | digitFormat }}</span>
        <i class="fa fa-clock ms-1"></i>
      </div>
      <div>
        <span>{{ operation.quantityCorrection ? operation.quantityToPlan + operation.quantityCorrection : operation.quantityToPlan | digitFormat }}</span>
        <!-- <span>{{ operation.quantityToPlan | digitFormat }}</span> -->
        <span>/</span>
        <span>{{ operation.quantityFinishedTotal | digitFormat }}</span>
        <span>/</span>
        <span>{{ operation.quantityCorrection ? operation.quantity + operation.quantityCorrection : operation.quantity | digitFormat }}</span>
        <!-- <span>{{ operation.quantity | digitFormat }}</span> -->
        <i class="fa fa-layer-group ms-1"></i>
      </div>
      <div>
        <button
          style="width: 115px;"
          type="button"
          class="btn btn-secondary btn-sm mt-3"
          *ngIf="datesWithPopulatedShifts.length !== 0"
          (click)="onOpenOperationDisplacementModal(operation)"
          ngxClickStopPropagation>
          Pomeri operaciju
        </button>
      </div>
    </div>
  </div>

  <div class="col" *ngFor="let day of operation.dates | slice: sliceStart:sliceEnd; trackBy: trackByFn">
    <div
      class="day"
      [class.day--is-deadline]="dateHelper.isPastDeadline(order.deliveryDeadline, day.date)"
      [class.day--is-disabled]="dateHelper.isPastDay(day.date)">
      <div class="day__shifts">
        <div class="day__shift" *ngFor="let shift of day.shifts; trackBy: trackByFn; let i = index">
          <div class="day__shift-icons day__shift-icons--up">
            <i *ngIf="shift?.employeesOverload" class="fa fa-user text-red"></i>
            <i *ngIf="shift?.machineOverload" class="fa fa-cog text-red"></i>
          </div>
          <!-- Employee time-->
          <div *ngIf="viewOptionKey === 'timeEmployee'">
            <div class="fw-bold" [innerText]="(shift.timeConsumedEmployee | digitFormat) || '-'"></div>

            <div class="fw-bold border-top" [innerText]="(shift.timePlannedEmployee | digitFormat) || '-'"></div>
          </div>
          <!-- Machine time-->
          <div
            *ngIf="viewOptionKey === 'timeMachine'"
            class="fw-bold"
            [innerText]="(shift.timePlannedMachine | digitFormat) || '-'"></div>

          <!-- Quantity-->
          <div *ngIf="viewOptionKey === 'quantity'" class="p-2 text-center">
            <div class="fw-bold border-bottom" [innerText]="(shift.quantityFinished | digitFormat) || '-'"></div>
            <input
              type="text"
              (change)="onChange(operation.id, day.date, shift.shiftNumber, shift.quantityPlanned)"
              [disabled]="dateHelper.isPastDay(day.date) || sector?.length === 0 || !isQuantityEditable"
              (keyup.enter)="onSubmitOperationQuantity(operation.id || operation.workOrderOperationId, operation.sector, day.date, shift.shiftNumber, shift.quantityPlanned)"
              class="form-control day__shift-input"
              mask="separator.2"
              thousandSeparator="."
              decimalMarker=","
              [(ngModel)]="shift.quantityPlanned"
              maxlength="13" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-operation-details-modal
  *ngIf="isDetailsModalVisible"
  [orderId]="order.id"
  [operation]="operation"
  (responseChanged)="onCloseDetailsModal($event)"></app-operation-details-modal>

<app-question-modal
  *ngIf="isDeviationModalOpen"
  [text]="'Da li želite da ignorišete odstupanje od plana?'"
  (responseChanged)="onIgnoreDeviation($event)"></app-question-modal>

<app-operation-displacement
  *ngIf="isOperationDisplacementModal"
  [operation]="selectedOperation"
  (responseChanged)="handleOperationDisplacementModal()"></app-operation-displacement>
